import { useMutation } from "@tanstack/react-query";
import { updateSevenRoomsSyncSettings } from "../../api/bSevenroomsApi";

export const useUpdateSevenRoomsSyncSettings = () => {
  return useMutation({
    mutationKey: ["update-sevenrooms-sync-settings"],
    mutationFn: (data) => updateSevenRoomsSyncSettings(data),
    onError: (error) => {
      console.error("SevenRooms sync settings error:", error.response || error);
    },
  });
};
